import EventEmitter from './utils/EventEmitter';

var dispatcher = new EventEmitter();

export default dispatcher;